import styled, { keyframes } from "styled-components";
import React, { useEffect, useState } from "react";
import Checkbox from "new_components/atoms/Checkbox";
import { useSelector, shallowEqual } from "react-redux";

const getCategoryOptions = (categories, parentId) => {
  const parentCategory = categories.find(
    (category) => category.id === parentId
  );
  return parentCategory
    ? parentCategory.options.map(({ id, name }) => ({ id, name }))
    : [];
};

const ReportOptions = ({
  next,
  filteredOptions,
  nomenclature,
  selectedCategory: preSelected,
  onSelect,
}) => {
  const [selectedCategories, setSelectedCategories] = useState(
    preSelected || []
  );
  const [checkAll, setCheckAll] = useState(false);

  useEffect(() => {
    setCheckAll(
      selectedCategories.length === filteredOptions.length &&
        filteredOptions.length > 0
    );
  }, [selectedCategories, filteredOptions]);

  const handleCategorySelected = (id) => {
    setSelectedCategories((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((c) => c !== id)
        : [...prevSelected, id]
    );
  };

  const handleCheckAll = (checkAll) => {
    const selected = checkAll
      ? filteredOptions.map((category) => category.id)
      : [];

    setSelectedCategories(selected);
    onSelect(selected);
  };

  useEffect(() => {
    onSelect(selectedCategories);
  }, [selectedCategories]);

  return (
    <Container>
      <T1>Select the {nomenclature?.toLowerCase() || "report"} target</T1>
      <Description>
        Please select a target for your{" "}
        {nomenclature?.toLowerCase() || "report"}. You'll have the opportunity
        to select additional options in the next step.
      </Description>
      <SelectArea>
        <CheckboxContainer key="checkAll" active={checkAll}>
          <Checkbox
            key="checkAll"
            checked={checkAll}
            onChange={() => {
              setCheckAll(!checkAll);
              handleCheckAll(!checkAll);
            }}
          />
          <CheckboxLabel>Check All</CheckboxLabel>
        </CheckboxContainer>
        {filteredOptions?.map((category) => (
          <CheckboxContainer
            key={category.id}
            active={selectedCategories.includes(category.id)}
          >
            <Checkbox
              checked={selectedCategories.includes(category.id)}
              onChange={() => handleCategorySelected(category.id)}
            />
            <CheckboxLabel>{category.name}</CheckboxLabel>
          </CheckboxContainer>
        ))}
      </SelectArea>
    </Container>
  );
};

// Styled Components
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Container = styled.div``;

const T1 = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
  font-family: "Raleway";
  color: #2a3039;
  line-height: 1.5;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  letter-spacing: -0.35px;
`;

const Description = styled.div`
  font-size: 16px;
  color: #2a3039;
  margin-bottom: 20px;
  line-height: 1.4;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  animation-delay: 0.5s;
`;

const SelectArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  width: 100%;
`;

const CheckboxContainer = styled.div`
  width: calc(30% - 5px);
  display: flex;
  align-items: center;
  font-family: "Raleway";
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 10px;
  margin: 5px;
  background-color: ${({ active }) => (active ? "#D5E2F9" : "#fff")};
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  animation-delay: 1s;
`;

const CheckboxLabel = styled.span`
  margin-left: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  animation-delay: 1s;
`;

const Button = styled.div`
  color: #2d70e2;
  border: 1px solid #2d70e2;
  font-size: 16px;
  padding: 10px 20px;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  font-family: "Raleway";
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export default ReportOptions;
